import { EstatePlanningFlowTableDTO } from '../../api/useEstatePlanningFlowQuery';

export enum ValueLessHeaderId {
  Summary = 0,
}

export interface Header {
  name: string;
  id: number;
  additionalInfo: string | null;
  categoryName: string;
  categoryId: number;
  collapsed: boolean;
  data: CategoryData;
}

export interface CategoryData extends Omit<EstatePlanningFlowTableDTO, 'header'> {
  headerId: number;
  collapsed: boolean;
  headerName: string;
}

export interface Category {
  name: string;
  id: number;
  additionalInfo: string | null;
  total?: number;
  headers: Header[];
  showObligationsExceedLiquidAssetsWarning: boolean;
}

export interface FilteredCategoryAndHeaders extends Category {
  filteredHeaders: Header[];
}

export interface CollapsableHeadersData {
  category: Record<string, number>;
  header: Record<
    string,
    {
      categoryId: number;
      collapsedData: Header;
      singleData: Header[];
    }
  >;
}

export enum EstateKeys {
  InEstateAssets = 'inEstateAssets',
  OutOfEstate = 'outEstateAssets',
}

export enum LiquidityKeys {
  LiquidAssets = 'liquidAssets',
  IlliquidAssets = 'illiquidAssets',
}

export interface Asset {
  description: string;
  additionalInfo: string | null;
  assetId: string;
  value: number | null;
  collapsed: boolean;
  headerId: number;
  name: string;
}

export interface Totals {
  headerId: number;
  collapsed: boolean;
  value: number | null;
  headerName: string;
}

export type AssetGroup = Record<
  string,
  {
    totals: Totals[];
    child: {
      [key: string]: Asset[];
    };
  }
>;

export interface Liquidity {
  name: string;
  id: number;
  totals: Totals[];
  assets: AssetGroup;
}

export interface Estate {
  name?: string;
  id?: number;
  totals: Totals[];
  liquidAssets: Liquidity;
  illiquidAssets: Liquidity;
}

export interface Body {
  inEstateAssets: Estate;
  outEstateAssets: Estate;
  totals: Totals[];
}
